import { useEffect, useRef } from 'react';

export interface UseForceRefreshProps {
  forceRefresh: number | undefined;
  forceReloadAllData: () => void;
}

/**
 * Handles force refresh trigger (e.g., from tab switching)
 * Monitors forceRefresh prop changes and triggers data reload
 */
export function useForceRefresh({ forceRefresh, forceReloadAllData }: UseForceRefreshProps): void {
  const prevForceRefreshRef = useRef(forceRefresh);

  useEffect(() => {
    if (forceRefresh !== prevForceRefreshRef.current && forceRefresh && forceRefresh > 0) {
      // Force reload all data
      forceReloadAllData();
      prevForceRefreshRef.current = forceRefresh;
    }
  }, [forceRefresh, forceReloadAllData]);
}
